import { render } from "./QRCodeModal.vue?vue&type=template&id=70a0702a&ts=true"
import script from "./QRCodeModal.vue?vue&type=script&lang=ts"
export * from "./QRCodeModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__